import * as _ from 'lodash';

import Locator from '../Locator';
import { isLinuxFetcher } from '../fetchers';
import { parseLinuxPackage, parseLinuxRevision } from '../linux';

import type { LocatorParts } from '../Locator';

/**
 * Render revisions with a special case for linux revisions
 * Returns a non-linux revision as-is. Returns a linux revision rendered as `packageName, arch`
 *
 * @param unparsedLocator Locator, LocatorParts or string - Strings will be parsed into locators
 * @param spacer string, default ', ' - spacer between package name and arch for
 * linux locators only.
 * @returns string - rendered revision
 */
export function renderRevision(unparsedLocator: Locator | LocatorParts | string, spacer: string = ', '): string {
  const locator = new Locator(unparsedLocator);
  const locRevision = locator.revision.value || '';

  if (isLinuxFetcher(locator.fetcher.value || '')) {
    const linuxRevision = parseLinuxRevision(locRevision);
    return _.isString(linuxRevision) ? linuxRevision : `${linuxRevision.revision}${spacer}${linuxRevision.arch}`;
  }

  return locRevision;
}

/**
 * Render package with special case for linux packages.
 * Returns a non-linux package name as-is. Returns a linux package name as `packageName - distro:distroVersion`
 *
 * @param unparsedLocator Locator, LocatorParts or string - Strings will be parsed into locators
 * @returns string - rendered package name
 */
export function renderPackage(unparsedLocator: Locator | LocatorParts | string): string {
  const locator = new Locator(unparsedLocator);
  const locPackage = locator.package.value || '';

  if (isLinuxFetcher(locator.fetcher.value || '')) {
    const linuxPackage = parseLinuxPackage(locPackage);
    return _.isString(linuxPackage) ? linuxPackage : `${linuxPackage.packageName} - ${linuxPackage.distro}:${linuxPackage.distroVersion}`;
  }

  return locPackage;
}
